// extracted by mini-css-extract-plugin
export var messageSideLeft = "_of-1";
export var stateContainer = "_of-0";